import ListTable2022 from "./ListTable2022";

function ListTable(props) {
  const { startDate, endDate } = props;

  const render = () => {
    return <ListTable2022 startDate={startDate} endDate={endDate} />;
  };

  return render();
}

export default ListTable;
